// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2q443","type":"styles_type__2lpIw","choices":"styles_choices__2g0Lu"};